import { TrendingUp } from "@mui/icons-material";
import { Box, Theme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { formatNum } from "src/lib/number.helpers";

import { getStyles } from "./utils/styles";
import { IntervalTab } from "../IntervalTabs/enum/IntervalTab";

export function TooltipExpectedVisitors({
  expectedVisitors,
  intervalTab,
  theme,
}: {
  expectedVisitors: number;
  intervalTab: IntervalTab;
  theme: Theme;
}) {
  const { t } = useTranslation();

  return (
    <Box style={getStyles(theme).expectedVisitors}>
      <Box style={getStyles(theme).iconBox}>
        <TrendingUp style={getStyles(theme).icon} />
      </Box>
      <Box style={getStyles(theme).expectedVisitorsNumber}>{formatNum(Math.floor(expectedVisitors))}</Box>
      <Box style={getStyles(theme).expectedVisitorsText}>{t(`expected visitors this ${intervalTab.toString().toLowerCase()}`)}</Box>
    </Box>
  );
}
